import { prepHandleEvent } from "./prepHandleEvent";

export function handleGestureChange(event) {
  var myApp = prepHandleEvent(this, false, null, null);
  if (myApp == null) return;

  if (myApp.HandleGesture(event)) {
    event.preventDefault();
    event.stopPropagation();
  }
}
